<script setup lang="ts">
import LeLock from "@dsk/icons/LeLock.vue";
import LeView from "@dsk/icons/LeView.vue";

const props = defineProps<{
  isUnlocked: boolean;
  isSelected: boolean;
}>();
</script>

<template>
  <div class="le-dictionary-upsell-icon">
    <LeView
      v-if="props.isUnlocked"
      class="le-dictionary-upsell-icon__view"
      :class="{ 'le-dictionary-upsell-icon__view--selected': props.isSelected }"
      role="presentation"
    />
    <LeLock
      v-else
      class="le-dictionary-upsell-icon__lock"
      :class="{ 'le-dictionary-upsell-icon__lock--selected': props.isSelected }"
      role="presentation"
    />
  </div>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all";

.le-dictionary-upsell-icon {
  padding: 4px;

  &__view {
    color: @colors[@secondary][800];

    &--selected {
      color: @colors[@accent][900];
    }
  }

  &__lock {
    color: @colors[@error][500];

    &--selected {
      color: @colors[@accent][900];
    }
  }
}
</style>
